import { deleteUser } from "@/api/users";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

interface GuardProps {
    isOnboardingComplete: boolean;
    userId: number;

}

const OnboardNavigationGuard: React.FC<GuardProps> = ({ isOnboardingComplete, userId }) => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const handleBeforeUnload = (event: BeforeUnloadEvent) => {
            if (!isOnboardingComplete) {
                event.preventDefault();
                event.returnValue = "Are you sure you want to leave before completing onboarding?";
            }
        };

        const handlePopState = async (event: PopStateEvent) => {
            if (!isOnboardingComplete) {
                const confirmLeave = window.confirm("Are you sure you want to leave before completing onboarding? \n Leaving will discard all progress.");
                if (!confirmLeave) {
                    // Prevent navigation and stay on the same page
                    navigate(location.pathname);

                } else {
                    navigate(`/admin/users`)
                }
            }
        };

        // Handle page unload
        window.addEventListener("beforeunload", handleBeforeUnload);

        // Handle back button
        window.addEventListener("popstate", handlePopState);

        // Clean up event listeners
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
            window.removeEventListener("popstate", handlePopState);
        };
    }, [isOnboardingComplete, navigate, location]);

    return null; // This component doesn't render anything
};

export default OnboardNavigationGuard;
